import routerOptions0 from "/home/runner/work/videlio/videlio/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.14.15_db0@0.2.4_encoding@0.1.13_eslint@9.20._jj2y2i7bibd7mbh5nycfkprwui/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}